import { sort_camp_card_list, update_aANDa_display, filter_ALL } from "../util/filter_campsites";
import { filter_by_rating } from "../util/filter_campsites";
import { getCookie_base64,initializeTooltips } from "../util/general_util";
declare global {
	interface Window {
		last_query_length: number;
	}
};

import * as noUiSlider from "nouislider";
import {searchParams, cgSearchResponse} from "../util/type_defs"
import { loadingIcon } from "../util/mustache_templates";
import mustache from 'mustache';
import { send_cgSearchRequest, send_ai_cg_search } from "../util/search_api";
import { freeForm_search_log } from "../log";
import { send_getAPItoken } from "../util/search_api";
import { cg_search_term_overrides } from '../util/consts';

export function init_genieScore_slider() {
	let slider: HTMLElement | null = document.querySelector(".range-slider");

	if (slider instanceof HTMLDivElement) {
		let sliderUI = slider.querySelector(".range-slider-ui") as noUiSlider.target;
		sliderUI.noUiSlider.on('update', (values: Array<string>, handle) => {
			let value_min: string = values[0];
			let value_max: string = values[1];
			value_min = value_min.replace(/[^\d^.]/g,'');
			value_max = value_max.replace(/[^\d^.]/g,'');

			filter_by_rating(parseFloat(value_min), parseFloat(value_max));
		});
	};
};

function handle_searchResponse(response:cgSearchResponse) {
	$("#camp_search_results").html(response.html);
	$("#camp_search_loading").html("");
	if ($("#camp_search_results").find(".card-body").length == 0) {
		$("#camp_search_results").html("<h3 class='text-center'>No Results - Please try a different search</h3>");
		if (!$("#index_loadMore-wrapper").hasClass("d-none")) $("#index_loadMore-wrapper").addClass("d-none");
		return;
	}

	$("#missingCampground_wrapper").removeClass("d-none");

	if (response.numResults !== undefined && response.numResults == 10) {
		$("#index_loadMore-wrapper").removeClass("d-none");
	};


	init_genieScore_slider();

	initializeTooltips();

	let sortBy:string = $("#sortBy_cgSearch").find(":selected").val() as string;
	sort_camp_card_list($("#camp_search_results > .campsiteCard_list_wrapper"),sortBy);

	let n_campsWith = response.filter_amenities_counts;
	Object.keys(n_campsWith).forEach((key) => {
		$(`#n-${key}`).html("(" + n_campsWith[key].toString() + ")");
	});

	$("#search_filters").collapse("show");
	if (response.filters !== undefined) {
		for (let key in response.filters) {
			if (response.filters[key] !== null) {
				if (key == "amenities") {
					for (let i:number = 0; i < response.filters[key].length; i++) {
		        $(`button.amenityToggleButton#${response.filters[key][i].toLowerCase().replace(" ","_")}:not(.active)`).trigger("click")
				 	};
				} else if (key == "activities") {
          for (let i:number = 0; i < response.filters[key].length; i++) {
						$(`button.activityToggleButton#${response.filters[key][i].toLowerCase().replace(" ","_")}:not(.active)`).trigger("click")
					};
				};
			};
		};
	};
	$("#sortBy_cgSearch").removeClass('d-none');
	if (!response.campNameSearch) filter_ALL();
	cgScrollToResults();
};

export async function send_search_req_freeForm(params:searchParams) {
	$("#autofill_results").html("");
	$("#search_filters").collapse("hide");
	$("#camp_search_results").html(loadingIcon);
	$("#missingCampground_wrapper").addClass("d-none");
	$("#index_loadMore-wrapper").addClass('d-none');

	$("#campsMarketingBS").addClass("d-none");
	let searchCookie:string|any = getCookie_base64("l_query");
	if (searchCookie.length) {
		searchCookie = JSON.parse(searchCookie);

		if (searchCookie.arguments !== undefined && searchCookie.arguments !== null) {
			// searchCookie.arguments = JSON.parse(searchCookie.arguments);
			/*
			 * de-select filters from last search
			 * while maintaining filters directly selected by user
			 */
			if (searchCookie.arguments.amenities !== undefined && searchCookie.arguments.amenities !== null) {
				for (let i:number = 0; i < searchCookie.arguments.amenities.length; i++) {
					$(`button.amenityToggleButton#${searchCookie.arguments.amenities[i].toLowerCase().replace(" ","_")}.active`).trigger("click")
				};
			};
			if (searchCookie.arguments.activities !== undefined && searchCookie.arguments.activities !== null) {
				for (let i:number = 0; i < searchCookie.arguments.activities.length; i++) {
					$(`button.activityToggleButton#${searchCookie.arguments.activities[i].toLowerCase().replace(" ","_")}.active`).trigger("click")
				};
			};
		};
	};

	const searchTerm:string = params.query.toLowerCase().trim();
	if (cg_search_term_overrides[searchTerm] != undefined) {
		params.query = cg_search_term_overrides[searchTerm];
	};

	let apiToken:string;
	apiToken = await send_getAPItoken();
	send_ai_cg_search(apiToken, params.query).then(gpt_response => {
		params.gpt_resp = gpt_response;

		send_cgSearchRequest(params).then(response => {
			handle_searchResponse(response);
		}).catch(e => {
			$("#camp_search_results").html("<h3 class='text-center'>No Results - Please try a different search</h3>");
		});
	}).catch(() => {
		//ai search failed: see if main app can complete search just based on autofill
		send_cgSearchRequest(params).then(response => {
			handle_searchResponse(response);
		}).catch(e => {
			$("#camp_search_results").html("<h3 class='text-center'>No Results - Please try a different search</h3>");
		});
	});
};

export function send_autofill_search_and_handle_response(query_type:string,query_val:string) {
	$("#search_filters").collapse("hide");
	$("#campsMarketingBS").addClass("d-none");

	$(".autofillOuterWrap").addClass("d-none");

	let searchCookie:string|any = getCookie_base64("l_query");
	if (searchCookie.length) {
		searchCookie = JSON.parse(searchCookie);

		if (searchCookie.arguments !== undefined && searchCookie.arguments !== null) {
			// searchCookie.arguments = JSON.parse(searchCookie.arguments);
			/*
			 * de-select filters from last search
			 * while maintaining filters directly selected by user
			 */
			if (searchCookie.arguments.amenities !== undefined && searchCookie.arguments.amenities !== null) {
				for (let i:number = 0; i < searchCookie.arguments.amenities.length; i++) {
					$(`button.amenityToggleButton#${searchCookie.arguments.amenities[i].toLowerCase().replace(" ","_")}.active`).trigger("click")
				};
			};
			if (searchCookie.arguments.activities !== undefined && searchCookie.arguments.activities !== null) {
				for (let i:number = 0; i < searchCookie.arguments.activities.length; i++) {
					$(`button.activityToggleButton#${searchCookie.arguments.activities[i].toLowerCase().replace(" ","_")}.active`).trigger("click")
				};
			};
		};
	};

	let query:string = $("#search_query").val() as string;

	send_autofill_search(query_type,query_val,query).then((response) => {

		init_genieScore_slider();
		$("#camp_search_loading").html("");

		$("#camp_search_results").html(response.html);
		if ($("#camp_search_results").find(".card-body").length == 0) {
			$("#camp_search_results").html("<h3 class='text-center'>No Results - Please try a different search</h3>");
			if (!$("#index_loadMore-wrapper").hasClass("d-none")) $("#index_loadMore-wrapper").addClass("d-none");
			return;
		}
		$("#missingCampground_wrapper").removeClass("d-none");

		if ((query_type != "camp_name") && (response.numResults !== undefined && response.numResults == 10)) {
			$("#index_loadMore-wrapper").removeClass("d-none");
		};

		initializeTooltips();

		let sortBy:string = $("#sortBy_cgSearch").find(":selected").val() as string;
		sort_camp_card_list($("#camp_search_results > .campsiteCard_list_wrapper"),sortBy);

		let n_campsWith = response.filter_amenities_counts;
		Object.keys(n_campsWith).forEach((key) => {
			$(`#n-${key}`).html(`(${n_campsWith[key].toString()})`);
		});

		if (response.filters !== undefined) {
			for (let key in response.filters) {
				if (response.filters[key] !== null) {
					if (key == "amenities") {
						for (let i:number = 0; i < response.filters[key].length; i++) {
							$(`button.amenityToggleButton#${response.filters[key][i].toLowerCase().replace(" ","_")}:not(.active)`).trigger('click')
						};
					} else if (key == "activities") {
						for (let i:number = 0; i < response.filters[key].length; i++) {
							$(`button.activityToggleButton#${response.filters[key][i].toLowerCase().replace(" ","_")}:not(.active)`).trigger('click')
						};
					};
				};
			};
		};

		if (!response.campNameSearch) {
			filter_ALL();
		};
		update_aANDa_display();
		cgScrollToResults();
	}).catch((e) => {
		$("#camp_search_loading").html("");
		const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
		$("#errorModal").modal("show");
	});
};

export function send_cg_search(query:string, topAutofill:{query_type:string, query_val:string}|null) {
	freeForm_search_log(query);

	$('#sidefilters').removeClass('d-none');
	$("#sortBy_cgSearchWrapper").removeClass("d-none");

	$("#autofill_results").html("");
	$("#autofill_results").css("border", "none");
	$("#autofill_results").css("padding","0");

	let params: searchParams = {
		query: query,
		autofillData: topAutofill
	};
	send_search_req_freeForm(params);
};

export async function cgScrollToResults() {
  try {
    // Wait for results to load
    await waitForChildren_cgResults().then(() => {
			$(".autofillOuterWrap").addClass("d-none");
			$('html, body').animate({
				scrollTop: $("#camp_search_results").offset().top - 200
			}, 250);
		});
    // Scroll to results

  } catch (err) {
    console.error(err); // Handle timeout error
  };
};
export async function waitForChildren_cgResults() {
	return new Promise<void>((resolve, reject) => {
		let timeoutId: ReturnType<typeof setTimeout> | undefined;
		let intervalId: ReturnType<typeof setInterval> | undefined;
		const check = () => {
			if ($('#camp_search_results').children().length >= 1) {
				if (timeoutId !== undefined) {
					clearTimeout(timeoutId);
				}
				clearInterval(intervalId); // Stop the interval
				resolve();
			}
		};
		const timeout = () => {
			if (timeoutId !== undefined) {
				clearTimeout(timeoutId);
			}
			clearInterval(intervalId); // Stop the interval
			reject('Timed out waiting for children');
		};
		timeoutId = setTimeout(timeout, 10000);
		// Wait for a small delay before starting the interval
		setTimeout(() => {
			intervalId = setInterval(check, 250); // Assign the intervalId variable
		}, 500);
	});
};

/*
 * update autofill suggestions when user types in search bar
 * if user typed ENTER, make campground search request to server
 */
export function campground_search() {
	let $autofill_suggestions = $("#autofill_results .search-suggestion");

	if ($autofill_suggestions.length == 1) {
		$autofill_suggestions.trigger("click");
		return;
	};

	$("#resultsCount").html("");
	let query:string = $("#search_query").val() as string;

	if (query.length < 1) return;

	let topAutofill:{query_type:string, query_val:string}|null = null;
	let cityAutofills:JQuery<HTMLElement> = $("#autofill_results .search-suggestion[query_type='city']");
	let campAutofills:JQuery<HTMLElement> = $("#autofill_results .search-suggestion[query_type='camp_name']");
	let poiAutofills:JQuery<HTMLElement> = $("#autofill_results .search-suggestion[query_type='poi']");

	if (cityAutofills.length) {
		topAutofill = {
			query_type: "city",
			query_val: $(cityAutofills[0]).attr("query_val") as string
		};
	} else if (campAutofills.length) {
		topAutofill = {
			"query_type": "camp_name",
			"query_val": $(campAutofills[0]).attr("query_val") as string
		};
	} else if (poiAutofills.length) {
		topAutofill = {
			"query_type": "poi",
			"query_val": $(poiAutofills[0]).attr("query_val") as string
		};
	};

	send_cg_search(query, topAutofill);
};

export const send_getInstantBook_camps = async (instantBook:boolean) => {
	let response:cgSearchResponse;
	let success:boolean = false;
	let errMsg:string;

	//Hide search button that just got called so it doesn't show up in between sets of results
	$("#camp_search_results").html("");
	$("#camp_search_loading").html(loadingIcon);
	$("#missingCampground_wrapper").addClass("d-none");


	await $.ajax({
		type: "post",
		url: "/getInstantBookCamps",
		data: JSON.stringify({instantBook:instantBook}),
		contentType:"application/json",
		dataType: "json",
		success: (data) => {response=data;success=true;filter_ALL()},
		error: (xhr,errStr,exc) => {errMsg=errStr;}
	});

	// filter_ALL()

	return new Promise<cgSearchResponse>((resolve,reject) => {
		if (success){
			resolve(response);
		}else{
			reject(Error(errMsg));
		}
	});
};

export const send_getNextSearchPage = async() => {
	let response:cgSearchResponse;
	let success:boolean = false;
	let errMsg:string;

	//Hide search button that just got called so it doesn't show up in between sets of results
	$("#camp_search_loading").html(loadingIcon);
	$("#missingCampground_wrapper").addClass("d-none");

	let instantBook:boolean = $("#instantBook").hasClass('active');


	await $.ajax({
		type: "post",
		url: "/campground_search_next",
		data: JSON.stringify({instantBook:instantBook}),
		contentType:"application/json",
		dataType: "json",
		success: (data) => {response=data;success=true;filter_ALL()},
		error: (xhr,errStr,exc) => {errMsg=errStr;}
	});

	filter_ALL()

	return new Promise<cgSearchResponse>((resolve,reject) => {
		if (success){
			resolve(response);
			filter_ALL();
		}else{
			reject(Error(errMsg));
		}
	});
};

//search by a search suggestion, get type of suggestion and value
export const send_autofill_search = async(query_type:String,query_val:String, query:string) => {

	let response:cgSearchResponse;
	let success:boolean = false;
	let errMsg:string;

	$("#camp_search_results").html(mustache.render(loadingIcon,{}));
	$("#missingCampground_wrapper").addClass("d-none");
	$("#search-suggestions-wrapper").addClass("d-none");
	$("#search-suggestions-wrapper").html("");
	$("#index_loadMore-wrapper").addClass("d-none");

	let instantBook:boolean = $("#instantBook").hasClass('active');

	let sortBy:string = $("#sortBy_cgSearch").find(":selected").val() as string;
  		sort_camp_card_list($("#camp_search_results > .campsiteCard_list_wrapper"),sortBy);

	await $.ajax({
		type:"post",
		url: "/autofill_cgSearch",
		data: JSON.stringify({
			type:query_type,
			value:query_val,
			instantBook:instantBook,
			query:query
		}),
		contentType:"application/json",
		dataType: "json",
		success: (data) => {
			response=data;success=true;},
		error: (xhr,errStr,exc) => {errMsg=errStr;}
	});

	$('#sidefilters').removeClass('d-none');
	$("#sortBy_cgSearchWrapper").removeClass("d-none");
	return new Promise<cgSearchResponse>((resolve,reject) => {
		if (success) resolve(response);
		else reject (Error(errMsg));
	});


};

export function filter_instantBook_camps(instantBook:boolean) {
	$("#index_loadMore-wrapper").addClass('d-none');
	send_getInstantBook_camps(instantBook).then((response) => {
		handle_searchResponse(response);
	});
};

export function index_search_loadMore(preLoadMore_matchCount:number=null) {
	let preLoadMore_n_matchingFilters:number;
	let postLoadMore_n_matchingFilters:number;
	if (preLoadMore_matchCount == null) preLoadMore_n_matchingFilters = $(".campsite-card:not(.\\!amenity,.\\!rating,.\\!activity,.\\!sites,.\\!rvLW,.\\!price,.\\!discount,.\\!affiliate)").length;
	else preLoadMore_n_matchingFilters = preLoadMore_matchCount;

	filter_ALL();
	$("#index_loadMore-wrapper").addClass('d-none');

	send_getNextSearchPage().then((response) => {
		//Added id=ag-loadingIcon to the mustache template for loading icon
		$("#camp_search_loading").html("");
		$("#missingCampground_wrapper").removeClass('d-none')
		$("#camp_search_results").append(response.html);

		if ((response.numResults !== undefined) && (response.numResults === 10)) {
			$("#index_loadMore-wrapper").removeClass('d-none');
		};

		initializeTooltips();

		let sortBy:string = $("#sortBy_cgSearch").find(":selected").val() as string;
  		sort_camp_card_list($("#camp_search_results > .campsiteCard_list_wrapper"),sortBy);

		postLoadMore_n_matchingFilters = $(".campsite-card:not(.\\!amenity,.\\!rating,.\\!activity,.\\!sites,.\\!rvLW,.\\!price,.\\!discount,.\\!affiliate)").length;

		let nNewResults:number = postLoadMore_n_matchingFilters - preLoadMore_n_matchingFilters;
		if (nNewResults < 5) {
			if (response.html != "" && nNewResults != 0) {
				//only try to load more if server didn't already run out of results
				index_search_loadMore(preLoadMore_n_matchingFilters);
				filter_ALL()
			};
		};

		filter_ALL();

	  }).catch((e) => {
			$("#camp_search_loading").html("");
			const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
			$("#errorModal").modal("show");
	  });

	filter_ALL();
	update_aANDa_display();
};

export const send_genieSummaryFeedback = async (type:string,value:number,campID:string) => {

	await $.ajax({
		type:"post",
		url: "/submit_genieSummaryFeedback",
		data: JSON.stringify({
			type:type,
			value:value,
			campID:campID
		}),
		contentType:"application/json",
	});
};